import { Button, Col, Form, Input, message, Row, Spin, Card, Radio, Select, Space } from "antd";
import { useEffect, useState } from "react";
import _AdministratorService from "../../../modules/AdministratorService";
import _capitalProviderService from "../../../modules/capitalProviderService";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import { useHistory, useParams } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import StatusTag from "../../../components/StatusTag";
import {ExclamationCircleOutlined,CheckCircleOutlined, FileOutlined, WarningOutlined } from "@ant-design/icons";
const { Option } = Select;

const ConcludeLoanRequestForAdministrator = ({ applicantDetails }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const params = useParams();
    const history = useHistory();
    const ApplicationObjId = parseInt(params.Id);
    const administratorIdRaw = localStorage.getItem("administratorUserId");
    const administratorId = administratorIdRaw ? parseInt(administratorIdRaw) : null;
    const capitalProviderId = localStorage.getItem("capitalProviderUserId");
    const capitalProviderID = capitalProviderId ? parseInt(capitalProviderId) : null;
    const isCapitalProvider = JSON.parse(localStorage.getItem("IsCapitalProviderFlag"));
    const [capitalProviderList, setCapitalProviderList] = useState([]);

    const getAllCapitalProviderList = async () => {
        setLoading(true);
        try {
            const res = await _capitalProviderService.getAllCapitalProviderList();
            if (res.data.IsSuccess) {
                setLoading(false);
                setCapitalProviderList(res.data.Obj);
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllCapitalProviderList();
    }, []);


    const onFinish = async (values) => {
        let reqObj = {
            Section: "common",
            ApplicationId: ApplicationObjId,
            Comments: values.comment,
            ReviewCommentsBy_BankerId: administratorId ? administratorId : null,
            ReviewCommentsBy_LoanOfficerId: capitalProviderID ? capitalProviderID : null,
            ApplicationStatusId: parseInt(values.applicationStatus),
            LoanOfficerId: values.capitalProvider
        }
        setLoading(true);
        try {
            const res = await _AdministratorService.addApplicationReviewComment(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                if (isCapitalProvider) {
                    history.push(routes.capitalProviderDashboard.path);
                } else {
                    history.push(routes.administratorDashboard.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    };

    const appStatus = Form.useWatch('applicationStatus', form);

    const onValuesChange = (changedValues,) => {
        const fieldName = Object.keys(changedValues)[0];

        if (fieldName == "applicationStatus" && changedValues.applicationStatus === "4") {
            form.setFieldsValue({
                capitalProvider: capitalProviderList?.[0]?.Id
            });
        }

        if (changedValues.applicationStatus !== "4") {
            form.setFieldsValue({ capitalProvider: null });
        }
    };

    return (
        <>
            <Spin spinning={loading}>
                <Card
                    className="box-shadow cardViewMain conclude-loan-request-card mt10"
                    title={
                        <Row justify="space-between" align="middle">
                            <Col
                                className="gutter-row"
                                xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 24 }}
                                lg={{ span: 12 }}
                                xl={{ span: 19 }}
                                xxl={{ span: 19 }}
                            >
                                <h3>
                                    {isCapitalProvider ? "Conclude Loan Request" : "Send to Capital Provider"}
                                   
                                </h3>
                            </Col>


                        </Row>

                    }
                    style={{
                        borderRadius: 16,
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                    }}
                >
                    <div>
                        {/* <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            className="w100"
                        > */}
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            onValuesChange={onValuesChange}
                        >
                            <Row gutter={2} className="w100">
                                <Col
                                    className="gutter-row"
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 24 }}
                                    xl={{ span: 24 }}
                                    xxl={{ span: 24 }}
                                >
                                    {/* <Form.Item
                                        label="Application Status"
                                        name="applicationStatus"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Application Status is required",
                                            },
                                        ]}
                                    >
                                        {isCapitalProvider ? (
                                            <Radio.Group className="line-height">
                                                <Space direction="vertical">
                                                    <Radio value="8"
                                                        disabled={[6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        Loan Application Funded
                                                    </Radio>
                                                    <Radio value="10"
                                                        disabled={[6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        Loan Application Rejected
                                                    </Radio>
                                                    <Radio value="3"
                                                        disabled={[6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        Action Required for Loan Application
                                                    </Radio>
                                                </Space>
                                            </Radio.Group>
                                        ) : (
                                            <Radio.Group className="line-height">
                                                <Space direction="vertical">
                                                    <Radio value="4"
                                                        disabled={[4, 5, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        
                                                        Qualified
                                                    </Radio>
                                                    <Radio value="5"
                                                        disabled={[4, 5, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        Not Qualified
                                                    </Radio>
                                                    <Radio value="6"
                                                        disabled={[4, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                       
                                                        Action Required for Loan Application
                                                    </Radio>
                                                </Space>
                                            </Radio.Group>
                                        )
                                        }
                                    </Form.Item> */}
                                    <Form.Item
                                        label="Application Status"
                                        name="applicationStatus"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Application Status is required",
                                            },
                                        ]}
                                    >
                                        {isCapitalProvider ? (
                                            <Radio.Group className="line-height w100">
                                                <Space direction="vertical" className="w100">

                                                    <Radio
                                                        value="8"
                                                        className="w100 conclude-radio"
                                                        disabled={[6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        <div className="conclude-radio-card">
                                                            <span className="conclude-radio-icon success"><CheckCircleOutlined className="successColor" />
                                                            </span>
                                                            <div>
                                                                <div className="conclude-radio-title">
                                                                    Loan Application Funded
                                                                </div>
                                                                <div className="conclude-radio-desc">
                                                                    Approve and fund this application
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Radio>

                                                    <Radio
                                                        value="10"
                                                        className="w100 conclude-radio"
                                                        disabled={[6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        <div className="conclude-radio-card">
                                                            <span className="conclude-radio-icon danger"><ExclamationCircleOutlined className="exceptionColor"/></span>
                                                            <div>
                                                                <div className="conclude-radio-title">
                                                                    Loan Application Rejected
                                                                </div>
                                                                <div className="conclude-radio-desc">
                                                                    Decline this application
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Radio>

                                                    <Radio
                                                        value="3"
                                                        className="w100 conclude-radio"
                                                        disabled={[6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        <div className="conclude-radio-card">
                                                            <span className="conclude-radio-icon warning"><WarningOutlined className="warningIconColor" /></span>
                                                            <div>
                                                                <div className="conclude-radio-title">
                                                                    Action Required for Loan Application
                                                                </div>
                                                                <div className="conclude-radio-desc">
                                                                    Request additional information from applicant
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Radio>

                                                </Space>
                                            </Radio.Group>
                                        ) : (
                                            <Radio.Group className="line-height w100">
                                                <Space direction="vertical" className="w100">

                                                    <Radio
                                                        value="4"
                                                        className="w100 conclude-radio"
                                                        disabled={[4, 5, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        <div className="conclude-radio-card">
                                                            <span className="conclude-radio-icon success"><CheckCircleOutlined className="successColor" /></span>
                                                            <div>
                                                                <div className="conclude-radio-title">
                                                                    Qualified
                                                                </div>
                                                                <div className="conclude-radio-desc">
                                                                    Send application to capital provider
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Radio>

                                                    <Radio
                                                        value="5"
                                                        className="w100 conclude-radio"
                                                        disabled={[4, 5, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        <div className="conclude-radio-card">
                                                            <span className="conclude-radio-icon danger"><ExclamationCircleOutlined className="exceptionColor"/></span>
                                                            <div>
                                                                <div className="conclude-radio-title">
                                                                    Not Qualified
                                                                </div>
                                                                <div className="conclude-radio-desc">
                                                                    Applicant does not meet criteria
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Radio>

                                                    <Radio
                                                        value="6"
                                                        className="w100 conclude-radio"
                                                        disabled={[4, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                                    >
                                                        <div className="conclude-radio-card">
                                                            <span className="conclude-radio-icon warning"><FileOutlined className="fileIconColor" /></span>
                                                            <div>
                                                                <div className="conclude-radio-title">
                                                                    Action Required for Loan Application
                                                                </div>
                                                                <div className="conclude-radio-desc">
                                                                    Request additional information from consumer
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Radio>

                                                </Space>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>

                                </Col>

                                {/* <Col
                                    className="gutter-row"
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 12 }}
                                    lg={{ span: 12 }}
                                    xl={{ span: 16 }}
                                    xxl={{ span: 16 }}
                                >
                                    <Form.Item label="Comments" name="comment"
                                        rules={[{ required: true, message: "Comment is required" }]}
                                    >
                                        <Input.TextArea
                                            autoSize={{ minRows: 3, maxRows: 5 }}
                                            placeholder="Comments"
                                            disabled={applicantDetails?.Application_Status_Id === 8 || applicantDetails?.Application_Status_Id === 9 || applicantDetails?.Application_Status_Id === 10}
                                        />
                                    </Form.Item>
                                </Col> */}

                                {appStatus == "4" &&
                                    < Col
                                        className="gutter-row"
                                        xs={{ span: 24 }}
                                        sm={{ span: 24 }}
                                        md={{ span: 24 }}
                                        lg={{ span: 24 }}
                                        xl={{ span: 24 }}
                                        xxl={{ span: 24 }}
                                    >
                                        <Form.Item
                                            label="Assign to Capital Provider"
                                            name="capitalProvider"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Capital Provider is required"
                                                }
                                            ]}
                                            preserve={false}
                                        >
                                            <Select
                                                placeholder="Select Capital Provider"
                                                style={{ minWidth: 250 }}

                                            >
                                                {capitalProviderList?.map((obj) => (
                                                    <Option key={obj.Id} value={obj.Id}>
                                                        {obj.Name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                }
                            </Row>

                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Button
                                        style={{ width: "100%" }}
                                        htmlType="submit"
                                        type="primary"
                                        disabled={[4, 6, 8, 9, 10].includes(applicantDetails?.Application_Status_Id)}
                                    >
                                        Submit
                                    </Button>
                                </Col>

                                <Col
                                    xs={24} sm={24} md={24} lg={24} xl={24}
                                    className="adminappstatus hide"

                                >
                                    <Space align="center">
                                        <strong>Application Status:</strong>
                                        <StatusTag statusId={applicantDetails?.Application_Status_Id} />
                                    </Space>
                                </Col>
                            </Row>

                        </Form>
                    </div>
                </Card>
            </Spin>
        </>
    )
}

export default ConcludeLoanRequestForAdministrator;